<template>
  <PlanLearnMoreDialog :visible="visible" :planType="'tasks'" @closed="handleCloseDialog" />
</template>

<script>
import { ConfirmComponent } from '../common/service-dialog/confirm';
import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';
import { PlanLearnMoreDialog } from '@zoom/fe-billing-components';

export default {
  name: 'TasksLearnMoreDialog',
  mixins: [ConfirmComponent],
  components: {
    PlanLearnMoreDialog
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    visible(val) {
      if (this.$context && this.$context.is && this.$context.is.modal) {
        val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
      }
    }
  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
    handleCloseDialog() {
      this.visible = false;
    },
    handleOpen() {
      this.visible = true;
    },
    async handleSure() {
      this.visible = false;
      return Promise.resolve();
    },
    async handleCancel() {
      this.visible = false;
      return Promise.resolve();
    }
  }
};
</script> 